export default __webpack_public_path__ + "static/media/urbc-logo-white.423033da.png";